"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PieceImages = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Chessboard = _interopRequireWildcard(require("./components/Chessboard"));
var _ChessGame = _interopRequireDefault(require("./components/ChessGame"));
var _excluded = ["position", "onMove", "lastMove"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ChessboardComponent = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  console.log(props, "ChessboardComponent");

  // const [arrows, setArrows] = useState([]); // To store the arrows

  // const handleSquareRightClick = useCallback(
  //   (square) => {
  //     debugger;
  //     // Assuming you want to toggle arrows off if clicked again
  //     const existingArrowIndex = arrows.findIndex(
  //       (arrow) => arrow.from === square
  //     );
  //     if (existingArrowIndex !== -1) {
  //       // Remove the arrow if it already exists
  //       setArrows((currentArrows) =>
  //         currentArrows.filter((_, index) => index !== existingArrowIndex)
  //       );
  //     } else {
  //       // Add a new arrow (this example just points the arrow back to itself, you'll need logic to choose the 'to' square)
  //       const newArrow = { from: square, to: square }; // Update 'to' based on your logic
  //       setArrows((currentArrows) => [...currentArrows, newArrow]);
  //     }
  //   },
  //   [arrows, setArrows]
  // );

  // const handleArrowsChange = useCallback(
  //   (newArrows) => {
  //     // Update your arrows state based on the new arrows, if necessary
  //     // This can be useful if the chessboard package provides built-in functionality for modifying arrows
  //     setArrows(newArrows);
  //   },
  //   [setArrows]
  // );
  return /*#__PURE__*/_react["default"].createElement(_ChessGame["default"], _extends({
    position: props.position
  }, props), function (_ref) {
    var position = _ref.position,
      onMove = _ref.onMove,
      lastMove = _ref.lastMove,
      rest = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_Chessboard["default"], _extends({
      ref: ref
    }, rest, {
      disabled: props.disabled,
      position: position,
      onMove: onMove,
      lastMove: lastMove,
      restrictedPiece: props.restrictedPiece,
      restrictPiece: props.restrictPiece,
      annotation: props === null || props === void 0 ? void 0 : props.annotation
      // onSquareRightClick={handleSquareRightClick}
      // onArrowsChange={handleArrowsChange}
      // arrows={arrows}
    }));
  });
});
var PieceImages = exports.PieceImages = _Chessboard.pieceImages;
var _default = exports["default"] = ChessboardComponent;